import { getHeaders } from '../../core/xhrRequest';
import { createAction } from 'redux-api-middleware';

export const CHECK_COUPON = 'CHECK_COUPON';
export const CHECK_COUPON_SUCCESS = 'CHECK_COUPON_SUCCESS';
export const CHECK_COUPON_FAILURE = 'CHECK_COUPON_FAILURE';

export const CLEAR_COUPON = 'CLEAR_COUPON';

export const checkCoupon = coupon => createAction({
    types: [
        CHECK_COUPON,
        {
            type: CHECK_COUPON_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        CHECK_COUPON_FAILURE
    ],
    endpoint: `/api/coupon/check`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify({code: coupon}),
    credentials: 'include'
});

export const clearCoupon = () => ({
    type: CLEAR_COUPON,
    payload: null,
});